import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AnalyticsService, AuthenticationService, ProfileService, NotificationService, BrowserStorageKeys, ResponseStatus, UserTypes, URLS, deleteTypes } from '@core';
import { environment } from '@env/environment';
import { NzModalService } from 'ng-zorro-antd/modal';
import { API_ResponseStatus } from 'src/app/core/config/api-response.config';
import { DEACTIVATION_INSTRUCTIONS } from 'src/app/core/config/deactivation-instructions.config';
import { pageRoutes } from 'src/app/core/config/page-routes.config';
import { StorageService } from 'src/app/core/services/storage/storage.service';

@Component({
    selector: 'app-delete-account',
    templateUrl: './delete-account.component.html',
    styleUrls: ['./delete-account.component.less'],
    standalone: false
})
export class DeleteAccountComponent implements OnInit {
  deleteReasonForm!: FormGroup;
  deleteAccountReasons: any[] = [];
  isConfirmDelete: boolean = false;
  isDeleteReason: boolean = false;
  isDisabled: boolean = false;
  isRequired: boolean = false;
  loading: boolean = false;
  showDeleteOptions: boolean = false;
  showTempDeleteModal: boolean = false;
  userTypes = UserTypes;
  deactivationInstructions = DEACTIVATION_INSTRUCTIONS;
  user = JSON.parse(localStorage.getItem(BrowserStorageKeys.token)!);

  deleteType: string = '';
  isChecked: boolean = false;
  updatingAccountStatus: boolean = false;

  urls = URLS;
  deleteTypes = deleteTypes;


  constructor(
    private authService: AuthenticationService,
    private profileService: ProfileService,
    private notify: NotificationService,
    private modal: NzModalService,
    private storageSrv: StorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private analytics: AnalyticsService
  ) { }

  ngOnInit(): void { 
    this.getDeleteReasons();
    this.buildDeleteReasonForm();
  }
  
  buildDeleteReasonForm() {
    this.deleteReasonForm = this.formBuilder.group({
      delete_reason_id: [null, [Validators.required]],
      delete_note: [null, this.deleteNoteValidator ]
    })
  }

  getDeleteReasons() {
    this.profileService
      .getDeleteReasons()
      .then((res: any) => {
        if (res?.status === API_ResponseStatus.FAILED) {
          this.notify.error("", res?.message);
          return;
        }

        this.deleteAccountReasons = res?.data;
      })
  }

  private readonly deleteNoteValidator: ValidatorFn = delete_note => {
    return this.isRequired ? Validators.required(delete_note) : Validators.nullValidator(delete_note);
  }

  checkButton(value: any) {
    this.isDisabled = value;
    // if (value.$$__zorroPropDecorator__nzChecked) {
    //   this.isDisabled = false;
    // } else {
    //   this.isDisabled = true;
    // }
  }



  handleConfirmDeleteModalCancel() {
    this.isConfirmDelete = false;
    this.deleteReasonForm.reset();
  }

  handleDeleteReasonModalCancel() {
    this.isDeleteReason = false;
    this.modal.closeAll();
    this.deleteReasonForm.reset();
  }

  onDelete() {
    this.showDeleteOptions = true;
    // this.isDeleteReason = true;
  }

  displayTempDeleteModal() { 
    this.showDeleteOptions = false;
    this.showTempDeleteModal = true;
  }

  closeTempDeleteModal() {
    this.showTempDeleteModal = false;
  }

  showDeleteReasonModal(deleteType: string) {
    this.deleteType = deleteType;
    this.showDeleteOptions = false;
    this.showTempDeleteModal = false;
    this.isDeleteReason = true;
  }

  onDeleteReason() {
    if (this.isDeleteReasonFormValid()) {
      this.isConfirmDelete = true;
      this.isDeleteReason = false;
    } else {
      this.isDeleteReason = true;
    }
  }

  goBack() {
    this.showTempDeleteModal = false;
    this.showDeleteOptions = true;
  }

  closeDeleteOptionsModal() {
    this.showDeleteOptions = false;
    this.isChecked = false;
    this.isDisabled = false;
  }

  speakToSupport() {
    this.router.navigate([pageRoutes.enquiry.openTicket]);
  }

  onConfirmDeactivate() {
    this.updatingAccountStatus = true;
    this.profileService
      .deactivateAccount(this.deleteReasonForm.value)
      .then((res: any) => {
        if (res?.message == ResponseStatus.FAILED) {
          this.notify.error("", res?.message);
          this.updatingAccountStatus = false;
          return;
        }
        this.updatingAccountStatus = false;
        this.modal.closeAll();
        this.deleteType = '';
        this.deleteReasonForm.reset();
        this.authService.logout();
        this.notify.success("", res?.message);
        this.storageSrv.clearLocalStorage();
        this.storageSrv.clearSessionStorage();
        this.analytics.outboundClick('landing_page_after_delete');
        window.location.href = environment.LANDING_PAGE_URL;
      })
      .catch((err: any) => {
        this.updatingAccountStatus = false;
        console.error("", err.message);
      });
  }


   onConfirmDelete() {
    this.updatingAccountStatus = true;
    this.profileService
      .deleteAccount(this.deleteReasonForm.value)
      .then((res: any) => {
        if(res?.message == ResponseStatus.FAILED) {
          this.updatingAccountStatus = false;
          this.notify.error("", res?.message);
          return;
        }

        this.updatingAccountStatus = false;
        this.modal.closeAll();
        this.deleteType = '';
        this.deleteReasonForm.reset();
        this.authService.logout();
        this.notify.success("", res?.message);
        this.storageSrv.clearLocalStorage();
        this.storageSrv.clearSessionStorage();
        this.analytics.outboundClick('landing_page_after_delete');
        window.location.href = environment.LANDING_PAGE_URL;
      })
      .catch((err: any) => {
        this.updatingAccountStatus = false;
        console.error("", err?.error?.message);
      })
      
  }



  isSelectedReasonOther(reason: string) {
    const selectDeleteResaon = this.deleteAccountReasons.filter((e) => e.id === reason)[0]?.name;
    const deleteResaon = "Others";

    if (selectDeleteResaon?.toLowerCase() === deleteResaon?.toLowerCase()) {
      this.isRequired = true;
      return;
    }

    this.isRequired = false;
  }

  isDeleteReasonFormValid(): Boolean {
    this.deleteReasonForm.get('delete_reason_id')?.markAsDirty();
    this.deleteReasonForm.get('delete_reason_id')?.updateValueAndValidity();
    this.deleteReasonForm.get('delete_note')?.markAsDirty();
    this.deleteReasonForm.get('delete_note')?.updateValueAndValidity();

    if (
      this.deleteReasonForm.get('delete_reason_id')?.valid && !this.isRequired ||
      this.deleteReasonForm.get('delete_reason_id')?.valid && this.deleteReasonForm.get('delete_note')?.valid
    ) {
      return true;
    }

    return false;
  }

}
